import { render, staticRenderFns } from "./ToggleGroupDialog.vue?vue&type=template&id=654f985f&"
import script from "./ToggleGroupDialog.vue?vue&type=script&lang=ts&"
export * from "./ToggleGroupDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports